import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import { useMemo } from 'react'
import { Abi } from 'thirdweb/utils'
import { _getThirdwebContract } from '../utils'

const useContract = (contractAddress: string, abi?: Abi) => {
  const chain = useActiveOrDefaultChain()

  const contract = useMemo(() => {
    return _getThirdwebContract(contractAddress, chain, abi)
  }, [contractAddress, chain, abi])

  return {
    contract,
  }
}

export default useContract
